/** A welcoming first turn with useful, inert prompt suggestions. */
import React from 'react';
import {Pressable, StyleSheet, Text, View} from 'react-native';
import {Icon} from '../Icon';
import {d_auto_awesome, d_checklist, d_folder} from '../../shared/ui/iconPaths';
import {QuantisMark} from '../QuantisMark';
import {useSharedPalette} from '../theme';
import {quantisAIWelcomePrompts} from './quantisAIWelcomePrompts';
const promptIcons = {attention: d_checklist, brief: d_folder, task: d_auto_awesome};

export function QuantisAIWelcome({firstName, project, showPrompts, enabled, onPrompt}: {
  firstName: string; project: boolean; showPrompts: boolean; enabled: boolean; onPrompt: (prompt: string) => void;
}) {
  const palette = useSharedPalette();
  const name = (firstName ?? '').trim();
  const suggestions = quantisAIWelcomePrompts(project);
  return <View style={styles.welcome}>
    <View style={styles.mark}><QuantisMark size={60}/></View>
    <Text accessibilityRole="header" style={[styles.greeting, {color: palette.foreground}]}>{name ? `Hi ${name},` : 'Hi there,'}</Text>
    <Text style={[styles.question, {color: palette.muted}]}>What would you like to work on?</Text>
    {showPrompts && <View style={styles.prompts}>
      {suggestions.map(suggestion => <Pressable key={suggestion.label} accessibilityRole="button" accessibilityLabel={suggestion.label}
        accessibilityHint="Fills the composer. Review your message before sending."
        disabled={!enabled} accessibilityState={{disabled: !enabled}} onPress={() => {if (enabled) onPrompt(suggestion.prompt);}}
        style={({pressed}) => [styles.prompt, {opacity: pressed ? 0.6 : 1}]}>
        <Icon d={promptIcons[suggestion.kind]} size={18} color={palette.brand}/>
        <Text style={[styles.promptLabel, {color: palette.foreground}]}>{suggestion.label}</Text>
      </Pressable>)}
    </View>}
  </View>;
}
const styles = StyleSheet.create({
  welcome: {paddingHorizontal: 24, paddingVertical: 24, alignItems: 'center', gap: 6, width: '100%', maxWidth: 400, alignSelf: 'center'},
  mark: {alignItems: 'center', marginBottom: 14},
  greeting: {fontSize: 24, fontWeight: '600', lineHeight: 30, textAlign: 'center'},
  question: {fontSize: 15, lineHeight: 22, textAlign: 'center'},
  prompts: {gap: 4, marginTop: 24, width: '100%', maxWidth: 300},
  prompt: {minHeight: 44, flexDirection: 'row', alignItems: 'center', justifyContent: 'center', gap: 10, paddingVertical: 10},
  promptLabel: {flexShrink: 1, fontSize: 14, lineHeight: 20, textAlign: 'center'},
});
